import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { RetailerFooter } from "@faire/retailer-visitor-shared/components/Footer/RetailerFooter";
import { useSettingShowSideBarV2UI } from "@faire/retailer-visitor-shared/settings/useSettingShowSideBarV2UI";
import { AccountSettingsBanner } from "@faire/retailer-visitor-shared/views/settings/AccountSettingsBanner";
import { SideBar as SideBarBase } from "@faire/retailer-visitor-shared/views/settings/SideBar";
import { Family, Weight } from "@faire/web--source/slate/Font";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled, { css } from "styled-components";
export var CONTENT_PADDING_LEFT = "50px";
export var Layout = function(_param) {
    var ref = _param.ref, props = _object_without_properties(_param, [
        "ref"
    ]);
    var showV2UI = useSettingShowSideBarV2UI();
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    var children = props.children, page = props.page, notification = props.notification, isLoading = props.isLoading, className = props.className, fullWidth = props.fullWidth;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        ref: ref,
        children: [
            showV2UI ? null : /*#__PURE__*/ _jsx(AccountSettingsBanner, {}),
            isTabletAndBelow && showV2UI ? /*#__PURE__*/ _jsx(Heading, {
                variant: "subheadingSansMedium",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "j4pe1E",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Settings"
                        }
                    ]
                })
            }) : null,
            /*#__PURE__*/ _jsxs(ContentWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(SideBar, {
                        className: "retailer-settings-sidebar",
                        selected: page,
                        $showV2UI: showV2UI
                    }),
                    /*#__PURE__*/ _jsxs(Content, {
                        className: "main-content",
                        $fullWidth: fullWidth,
                        children: [
                            isLoading ? /*#__PURE__*/ _jsx(Loader, {
                                "data-test-id": "layout-loading-spinner"
                            }) : children,
                            (notification === null || notification === void 0 ? void 0 : notification.text) ? /*#__PURE__*/ _jsx(Notification, {
                                $type: notification.type,
                                children: notification.text
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(RetailerFooter, {
                noTopBorder: true
            })
        ]
    });
};
var Wrapper = styled.section.withConfig({
    componentId: "sc-1db78b53-0"
})([
    "display:flex;flex-direction:column;flex:1 1 0%;"
]);
var ContentWrapper = styled.section.withConfig({
    componentId: "sc-1db78b53-1"
})([
    "display:flex;border-bottom:1px solid #eaeaea;flex-direction:row;flex-grow:1;",
    "{flex-direction:column;}"
], responsiveMediaQueries.tabletAndBelow);
var SideBar = styled(SideBarBase).withConfig({
    componentId: "sc-1db78b53-2"
})([
    "width:270px;border-right:2px solid #eaeaea;display:flex;flex-direction:column;padding:42px 30px 42px 70px;",
    " ",
    "{width:100%;padding:15px;border-right:none;}"
], function(props) {
    return props.$showV2UI ? css([
        "width:220px;padding:42px 36px 42px 36px;"
    ]) : "";
}, responsiveMediaQueries.tabletAndBelow);
var Content = styled.section.withConfig({
    componentId: "sc-1db78b53-3"
})([
    "display:flex;flex-wrap:wrap;width:calc(100% - 270px);max-width:",
    ";align-content:flex-start;padding:20px ",
    ";position:relative;",
    "{padding:0 15px;max-width:100%;width:100%;}"
], function(param) {
    var $fullWidth = param.$fullWidth;
    return $fullWidth ? undefined : "800px";
}, CONTENT_PADDING_LEFT, responsiveMediaQueries.tabletAndBelow);
var Notification = styled.section.withConfig({
    componentId: "sc-1db78b53-4"
})([
    "background-color:",
    ";width:100%;padding:15px 10px;text-align:center;font-size:12px;color:#ffffff;letter-spacing:0.3px;text-align:center;flex:100%;position:fixed;bottom:0;left:0;font-family:",
    ";font-weight:",
    ";z-index:1;"
], function(param) {
    var $type = param.$type;
    return $type === "success" ? Decorative.shade.orange : Core.surface.critical;
}, Family.sansSerif, Weight.medium);
var Loader = styled(LoadingSpinner).withConfig({
    componentId: "sc-1db78b53-5"
})([
    "position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;width:50px;height:50px;"
]);
var Heading = styled(Typography).withConfig({
    componentId: "sc-1db78b53-6"
})([
    "margin:40px 16px 0 16px;"
]);
